export default {
  title: 'Eksklusive tilbud',
  header: {
    back: 'Tilbage',
    title: 'Belønninger',
  },
  info: {
    title: 'Du har {{points}} point.',
    description: 'Brug {{amount}} og få 5 point! Læg varer i kurven gratis med dine optjente point.',
  },
  rewards: {
    data: [
      {
        title: 'Optjen point for hver ordre',
        description: 'For hver {{amount}} du bruger, får du 5 point på din konto.',
      },
      {
        title: 'Optjen point for hver ordre',
        description:
          'Indløs dine point til gratis lækkerier! Begynd at bruge point fra 350 point, svarende til et forbrug på {{amount}}.',
      },
      {
        title: 'Optjen point for hver ordre',
        description: 'Opdag eksklusive tilbud, kampagner og rabatter. Se medlemskampagner i appen.',
      },
    ],
  },
};
